var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "880px",
    height: "191px",
    viewBox: "0 0 880 191",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DEC5F8F1-2855-43E9-A61E-5B1A06D349A1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "96.5829526%",
    y1: "50.0346329%",
    x2: "9.05009128%",
    y2: "49.9940045%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D8C9D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFF1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "59.7317345%",
    y1: "50.1398754%",
    x2: "33.3020048%",
    y2: "49.8918233%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6A80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.7910501%",
    y1: "51.8870472%",
    x2: "31.1926821%",
    y2: "49.9893852%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCD4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "51.0042249%",
    y1: "92.4999401%",
    x2: "49.1843817%",
    y2: "5.39406489%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6D82",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6C1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "44.2499536%",
    y1: "18.0908653%",
    x2: "53.4790242%",
    y2: "101.639075%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849098",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.1073102%",
    y1: "84.9720408%",
    x2: "58.8735229%",
    y2: "31.4320548%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF9FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2D2D2",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.3544205%",
    y1: "33.4561153%",
    x2: "60.0712883%",
    y2: "76.7732393%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849098",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.3544205%",
    y1: "34.3750377%",
    x2: "60.0712883%",
    y2: "75.2861322%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849098",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "33.3544205%",
    y1: "44.5587262%",
    x2: "60.0712883%",
    y2: "58.8057025%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DADADA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#849098",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "43.8862013%",
    y1: "-25.8928257%",
    x2: "58.3432682%",
    y2: "35.9045702%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6D6D6D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "69.6486026%",
    y1: "88.8307297%",
    x2: "32.2340266%",
    y2: "17.3920661%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6D82",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6C1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "60.2024122%",
    y1: "81.777375%",
    x2: "41.238479%",
    y2: "4.23096012%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCD4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "41.1812968%",
    y1: "50.1814937%",
    x2: "39.441812%",
    y2: "49.8375278%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6B6A80",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-2.82633857%",
    y1: "52.1550847%",
    x2: "75.789058%",
    y2: "49.7447176%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCD4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "74.0825022%",
    y1: "81.1342843%",
    x2: "28.0982126%",
    y2: "24.5445512%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E6D82",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B6B6C1",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "63.6331245%",
    y1: "71.5944422%",
    x2: "37.7759588%",
    y2: "15.1128158%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0B0BB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDCCD4",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.604073661
  }, /*#__PURE__*/React.createElement("g", {
    id: "Errors-401",
    transform: "translate(-562.000000, -650.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-recolor",
    transform: "translate(562.560385, 650.110100)",
    opacity: 0.6041
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(0.000000, 59.714750)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.130894,63.5941905 C614.285053,75.9753603 587.9985,69.2219949 554.627627,46.7107771 C456.006446,-19.5097221 386.28183,-10.6928285 294.558538,49.1494923 C274.983445,61.9058491 243.476868,83.1039126 190.530903,68.096434 C112.976249,45.9604031 33.3708724,68.2840275 0,129.627096 L878.26916,129.627096 C853.287613,81.7907582 759.886457,8.25411322 641.130894,63.5941905",
    id: "Fill-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(178.227918, 118.087595)",
    fill: "url(#linearGradient-2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.186429455,71.2855232 C4.101448,64.1569709 23.1172524,50.0874597 47.5395109,53.8393294 C74.0124935,57.966386 79.978236,48.9618989 90.7911444,45.2100292 C110.739096,38.2690704 126.212741,61.1554752 133.110631,46.7107771 C141.872815,28.3266158 156.227883,19.1345352 200.038805,37.331103 C210.478854,41.645753 209.733136,32.0784855 214.393873,26.450681 C223.528916,15.570259 234.714683,35.6427616 239.748279,34.5172007 C245.527592,33.2040463 243.849727,24.7623396 247.205457,17.4461938 C254.289776,2.25112179 266.407691,16.5082264 274.797016,15.1950721 C283.186341,13.8819177 287.660648,-2.81390223 297.168551,0.562780447 C317.489361,7.87892625 311.15076,50.2750532 309.845753,59.6547273 C315.625067,51.5882076 325.692257,45.5852162 325.692257,71.0979298 L0.186429455,71.0979298",
    id: "Fill-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(266.676846, 149.622350)",
    fill: "url(#linearGradient-3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.050724,39.7698182 L100.299047,39.7698182 C105.332642,19.3221287 85.3846902,29.6397702 85.3846902,29.6397702 C85.3846902,29.6397702 93.0282978,8.06651973 85.1982607,10.3176415 C77.7410825,12.3811698 74.3853524,29.2645832 74.3853524,29.2645832 C74.3853524,29.2645832 70.4703338,1.87593482 61.52172,0.187593482 C55.7424069,-0.937967411 60.2167138,26.2630875 60.2167138,26.2630875 C60.2167138,26.2630875 56.8609836,23.4491853 52.0138178,23.2615918 C47.9123698,23.2615918 48.8445171,28.5142093 48.8445171,28.5142093 C48.8445171,28.5142093 40.2687622,10.880422 35.7944553,11.0680154 C30.2015716,11.4432024 36.1673142,29.8273637 36.1673142,29.8273637 C36.1673142,29.8273637 25.1679764,17.8213808 20.8800989,18.0089743 C15.1007858,18.3841613 25.5408353,35.6427616 25.5408353,35.6427616 C25.5408353,35.6427616 17.5243687,30.7653311 8.01646654,31.7032985 C1.30500618,32.2660789 -1.30500618,35.0799812 2.050724,39.7698182",
    id: "Fill-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(701.606169, 0.000000)",
    fill: "url(#linearGradient-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.1152658,77.2885147 C56.1152658,119.872235 39.3366149,154.577029 27.7779887,154.577029 C16.0329331,154.577029 0.559288364,108.241439 0.559288364,65.6577188 C0.559288364,23.0739983 19.3886633,-4.31465009 32.9980135,0.562780447 C48.2852287,6.19058491 56.1152658,34.8923877 56.1152658,77.2885147",
    id: "Fill-16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(479.486302, 36.606608)",
    fill: "url(#linearGradient-5)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    points: "89.8589971 152.888688 0 152.888688 0 62.2810361 44.9294985 0 89.8589971 62.2810361 89.8589971 152.888688"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "url(#linearGradient-6)",
    points: "569.355554 189.469417 675.247484 189.469417 675.247484 98.8617651 569.355554 98.8617651"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(586.263887, 115.403785)",
    fill: "url(#linearGradient-7)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-23",
    points: "0 74.0994255 102.909059 74.0994255 102.909059 0 0 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "url(#linearGradient-8)",
    points: "689.229693 189.469417 795.121624 189.469417 795.121624 115.369992 689.229693 115.369992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#9D9D9C",
    points: "600.302844 189.469417 675.247484 189.469417 675.247484 132.065811 600.302844 132.065811"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(524.416139, 36.606608)",
    fill: "url(#linearGradient-9)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    points: "105.89193 0 150.821429 62.2810361 44.9294985 62.2810361 0 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#FFFFFF",
    points: "600.302844 189.09423 604.590721 189.09423 604.590721 131.690624 600.302844 131.690624"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "var(--tru-light)",
    x: 604.031433,
    y: 131.690624,
    width: 25.7272647,
    height: 53.2765489
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "var(--tru-light)",
    x: 629.758697,
    y: 131.690624,
    width: 46.0480753,
    height: 53.2765489
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-162",
    transform: "translate(605.578078, 138.565699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-50"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.7944553,36.580729 C35.7944553,40.5201922 33.5573018,43.5216879 30.76086,43.5216879 C27.9644182,43.5216879 25.7272647,40.3325987 25.7272647,36.580729 C25.7272647,32.6412659 27.9644182,29.6397702 30.76086,29.6397702 C33.3708724,29.4521767 35.7944553,32.6412659 35.7944553,36.580729",
    id: "Fill-1",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6080258,36.580729 C35.6080258,39.7698182 34.4894491,42.2085335 32.9980135,42.2085335 C31.5065778,42.2085335 30.3880011,39.7698182 30.3880011,36.580729 C30.3880011,33.3916398 31.5065778,30.9529246 32.9980135,30.9529246 C34.4894491,30.9529246 35.6080258,33.3916398 35.6080258,36.580729",
    id: "Fill-3",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1481989,34.3296072 C72.1481989,40.1450052 70.2839044,44.8348422 68.2331804,44.8348422 C65.9960269,44.8348422 64.3181618,40.1450052 64.3181618,34.3296072 C64.3181618,28.5142093 66.1824564,23.8243722 68.2331804,23.8243722 C70.2839044,23.8243722 72.1481989,28.5142093 72.1481989,34.3296072",
    id: "Fill-5",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.4024811,34.5172007 C71.4024811,38.4566638 70.6567633,41.4581596 69.9110455,41.4581596 C68.9788982,41.4581596 68.4196098,38.2690704 68.4196098,34.5172007 C68.4196098,30.5777376 69.1653276,27.5762419 69.9110455,27.5762419 C70.6567633,27.3886484 71.4024811,30.5777376 71.4024811,34.5172007",
    id: "Fill-7",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2160516,34.7047942 C71.2160516,37.331103 70.6567633,39.3946313 70.0974749,39.3946313 C69.5381865,39.3946313 68.9788982,37.331103 68.9788982,34.7047942 C68.9788982,32.0784855 69.5381865,30.0149572 70.0974749,30.0149572 C70.8431927,30.0149572 71.2160516,32.0784855 71.2160516,34.7047942",
    id: "Fill-9",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8431927,35.0799812 C70.8431927,36.580729 70.6567633,37.7062899 70.2839044,37.7062899 C69.9110455,37.7062899 69.724616,36.580729 69.724616,35.0799812 C69.724616,33.5792333 69.9110455,32.4536724 70.2839044,32.4536724 C70.6567633,32.4536724 70.8431927,33.5792333 70.8431927,35.0799812",
    id: "Fill-11",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2160516,33.9544203 C71.2160516,35.6427616 70.6567633,37.1435095 70.0974749,37.1435095 C69.5381865,37.1435095 68.9788982,35.8303551 68.9788982,33.9544203 C68.9788982,32.2660789 69.5381865,30.7653311 70.0974749,30.7653311 C70.8431927,30.7653311 71.2160516,32.2660789 71.2160516,33.9544203",
    id: "Path",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7279269,36.3931355 C14.7279269,41.8333465 11.5586262,46.3355901 7.45717818,46.3355901 C3.54215964,46.3355901 0.186429455,41.8333465 0.186429455,36.3931355 C0.186429455,30.9529246 3.35573018,26.450681 7.45717818,26.450681 C11.3721967,26.450681 14.7279269,30.9529246 14.7279269,36.3931355",
    id: "Fill-15",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6093502,36.7683225 C13.6093502,41.4581596 11.7450556,45.2100292 9.32147273,45.2100292 C6.89788982,45.2100292 5.03359527,41.4581596 5.03359527,36.7683225 C5.03359527,32.0784855 6.89788982,28.3266158 9.32147273,28.3266158 C11.5586262,28.3266158 13.6093502,32.2660789 13.6093502,36.7683225",
    id: "Fill-17",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4907735,37.331103 C12.4907735,40.5201922 11.3721967,43.1465009 9.88076109,43.1465009 C8.57575491,43.1465009 7.45717818,40.5201922 7.45717818,37.331103 C7.45717818,34.1420138 8.57575491,31.515705 10.0671905,31.515705 C11.3721967,31.7032985 12.4907735,34.1420138 12.4907735,37.331103",
    id: "Path",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1488611,36.3931355 C61.1488611,41.8333465 58.1659898,46.3355901 54.6238302,46.3355901 C50.8952411,46.3355901 48.0987993,41.8333465 48.0987993,36.3931355 C48.0987993,30.9529246 51.0816705,26.450681 54.6238302,26.450681 C58.1659898,26.2630875 61.1488611,30.7653311 61.1488611,36.3931355",
    id: "Fill-21",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0302844,36.2055421 C60.0302844,40.1450052 58.5388487,43.3340944 56.8609836,43.3340944 C55.1831185,43.3340944 53.6916829,40.1450052 53.6916829,36.2055421 C53.6916829,32.2660789 55.1831185,29.0769897 56.8609836,29.0769897 C58.5388487,29.0769897 60.0302844,32.2660789 60.0302844,36.2055421",
    id: "Path",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6574255,36.2055421 C59.6574255,39.3946313 58.5388487,41.8333465 57.0474131,41.8333465 C55.5559775,41.8333465 54.4374007,39.2070378 54.4374007,36.2055421 C54.4374007,33.2040463 55.5559775,30.5777376 57.0474131,30.5777376 C58.5388487,30.5777376 59.6574255,33.2040463 59.6574255,36.2055421",
    id: "Fill-25",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7252782,36.7683225 L59.8438549,37.1435095 L59.8438549,35.2675747 L58.9117076,35.0799812 L59.6574255,33.9544203 L59.2845665,32.2660789 L58.3524193,33.5792333 C58.1659898,33.0164529 57.9795604,32.6412659 57.6067015,32.2660789 L57.420272,29.6397702 L55.9288364,29.6397702 L56.3016953,32.2660789 C55.9288364,32.6412659 55.7424069,33.0164529 55.5559775,33.7668268 L54.2509713,32.2660789 L53.8781124,34.1420138 L55.369548,35.4551681 C55.369548,35.4551681 55.369548,35.4551681 55.369548,35.4551681 C55.369548,35.6427616 55.369548,35.6427616 55.369548,35.8303551 L54.0645418,35.6427616 L54.0645418,37.331103 L55.9288364,37.1435095 C55.9288364,37.1435095 55.9288364,37.1435095 55.9288364,37.331103 L54.0645418,38.8318508 L54.6238302,40.3325987 L56.1152658,38.4566638 C56.1152658,38.6442573 56.3016953,38.6442573 56.3016953,38.6442573 L55.7424069,42.02094 L57.6067015,42.02094 L57.6067015,38.6442573 C57.7931309,38.4566638 57.7931309,38.4566638 57.9795604,38.2690704 L59.2845665,39.7698182 L59.6574255,37.8938834 L58.5388487,36.955916 C58.7252782,36.955916 58.7252782,36.7683225 58.7252782,36.7683225",
    id: "Fill-27",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8431927,36.0179486 L71.4024811,36.3931355 L71.4024811,34.1420138 L70.8431927,34.7047942 L71.2160516,32.8288594 L71.0296222,30.7653311 L70.6567633,32.2660789 C70.6567633,31.515705 70.2839044,28.1390223 70.2839044,28.1390223 L69.5381865,28.1390223 C69.5381865,28.1390223 69.3517571,31.7032985 69.3517571,32.4536724 L68.6060393,30.5777376 L68.4196098,33.0164529 C68.4196098,33.0164529 69.3517571,35.0799812 69.3517571,35.2675747 L68.4196098,34.8923877 L68.4196098,36.7683225 L69.3517571,36.580729 C69.5381865,36.3931355 68.6060393,38.4566638 68.6060393,38.4566638 L68.9788982,40.1450052 L69.724616,37.1435095 C69.724616,37.331103 69.3517571,40.7077856 69.3517571,40.7077856 L70.0974749,40.5201922 L70.0974749,37.331103 C70.0974749,37.1435095 70.4703338,39.3946313 70.4703338,39.3946313 L70.8431927,37.331103 C71.2160516,37.331103 70.8431927,36.2055421 70.8431927,36.0179486",
    id: "Path",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    fill: "#7C809B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.1481989,35.4551681 C72.1481989,35.4551681 72.7074873,25.1375266 71.2160516,26.075494 C71.2160516,26.075494 69.3517571,27.7638354 69.5381865,32.4536724 C69.5381865,32.4536724 69.724616,38.0814769 67.3010331,38.6442573 L60.7760022,39.3946313 C60.7760022,39.3946313 61.8945789,35.2675747 59.6574255,30.3901441 C59.6574255,30.3901441 59.470996,22.1360309 57.0474131,25.5127136 C56.8609836,25.7003071 56.8609836,25.8879005 56.6745542,26.450681 C55.9288364,28.3266158 54.6238302,32.4536724 54.8102596,37.5186964 L54.8102596,37.5186964 C54.8102596,37.7062899 54.6238302,37.8938834 54.6238302,38.2690704 L54.6238302,38.2690704 C54.4374007,38.8318508 54.0645418,39.5822247 53.6916829,40.1450052 C53.6916829,40.1450052 50.1495233,40.3325987 45.115928,40.3325987 C33.3708724,40.7077856 12.4907735,41.0829726 3.54215964,39.9574117 C2.61001236,39.9574117 1.86429455,39.7698182 1.30500618,39.5822247 C1.30500618,39.5822247 0.559288364,38.4566638 0.186429455,37.1435095 C0,36.580729 0,36.2055421 0,35.8303551 C0,35.8303551 0,26.6382745 2.23715345,23.0739983 C2.23715345,23.0739983 2.050724,17.6337873 7.08431927,16.1330395 C7.08431927,16.1330395 8.202896,15.0074786 9.88076109,13.5067307 C13.9822091,9.75486107 21.2529578,3.1890892 23.1172524,2.62630875 C23.1172524,2.62630875 37.6587498,-1.68834134 54.8102596,1.12556089 C54.8102596,1.12556089 60.0302844,0.750373929 64.5045913,6.37817839 C64.5045913,6.37817839 65.4367385,7.50373929 66.3688858,9.37967411 C67.1146036,10.6928285 67.673892,12.3811698 67.8603215,14.0695112 C67.8603215,14.0695112 67.8603215,14.0695112 67.8603215,14.0695112 C68.0467509,14.4446981 70.0974749,16.5082264 70.2839044,17.2586004 C70.6567633,18.1965678 71.5889105,22.6988113 71.9617695,24.7623396 C71.9617695,24.7623396 74.3853524,32.2660789 72.1481989,35.4551681",
    id: "Fill-31"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.673892,14.0695112 C67.1146036,14.2571046 62.4538673,16.5082264 57.7931309,17.0710069 C57.7931309,17.0710069 57.7931309,17.0710069 57.7931309,17.0710069 C57.6067015,17.0710069 53.8781124,17.4461938 51.4545295,15.945446 C51.4545295,15.945446 51.4545295,15.945446 51.4545295,15.7578525 C51.8273884,15.570259 53.8781124,14.2571046 53.6916829,12.9439503 C53.6916829,12.9439503 53.6916829,12.9439503 53.6916829,12.9439503 L10.0671905,13.5067307 C10.0671905,13.5067307 10.0671905,13.5067307 10.0671905,13.3191372 C14.1686385,9.56726759 21.2529578,3.00149572 23.1172524,2.62630875 C23.1172524,2.62630875 37.6587498,-1.68834134 54.8102596,1.12556089 C54.8102596,1.12556089 60.2167138,0.562780447 64.5045913,6.37817839 C64.3181618,6.37817839 67.1146036,10.130048 67.673892,14.0695112 C67.673892,14.0695112 67.673892,14.0695112 67.673892,14.0695112",
    id: "Fill-34",
    fill: "#7C809B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69433164,13.5067307 L8.57575491,14.6322916 L7.83003709,14.2571046 L8.01646654,13.1315438 C9.50790218,10.505235 11.9314851,11.4432024 11.9314851,11.4432024 L9.69433164,13.5067307 Z",
    id: "Fill-36",
    fill: "var(--tru-grey-200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69433164,13.5067307 L8.57575491,14.6322916 C8.57575491,14.6322916 7.83003709,14.6322916 7.83003709,14.4446981 C7.83003709,13.6943242 8.01646654,13.3191372 8.01646654,13.3191372 C8.38932545,12.9439503 9.69433164,13.5067307 9.69433164,13.5067307",
    id: "Fill-38",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1488611,3.56427616 C61.1488611,3.56427616 55.9288364,-0.375186964 56.1152658,3.93946313 C56.1152658,3.93946313 57.0474131,15.1950721 58.9117076,16.8834134 C58.9117076,16.8834134 66.5553153,15.3826655 67.8603215,14.0695112 C68.0467509,13.6943242 64.5045913,5.44021098 61.1488611,3.56427616",
    id: "Fill-40",
    fill: "#D7D2CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0474131,7.12855232 C57.0474131,7.12855232 56.4881247,3.56427616 57.7931309,3.1890892 C57.7931309,3.1890892 58.9117076,3.00149572 59.0981371,3.1890892 C60.5895727,5.2526175 62.4538673,8.62930018 63.3860145,13.1315438 C63.3860145,13.1315438 60.5895727,15.0074786 59.2845665,14.0695112 C57.9795604,13.1315438 57.0474131,7.12855232 57.0474131,7.12855232",
    id: "Fill-42",
    fill: "#E4E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4031433,4.12705661 C60.4031433,4.12705661 64.8774502,6.56577188 65.9960269,12.1935763 C65.9960269,12.1935763 63.7588735,12.9439503 63.572444,12.7563568 C63.3860145,12.5687633 61.7081495,6.75336536 60.2167138,4.50224357 C60.2167138,4.50224357 59.8438549,3.93946313 60.4031433,4.12705661",
    id: "Fill-44",
    fill: "#E4E3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3036818,3.37668268 C24.608688,3.1890892 43.2516335,-0.562780447 54.0645418,3.37668268 C54.4374007,3.56427616 54.6238302,3.75186964 54.6238302,4.12705661 C54.6238302,6.37817839 54.6238302,13.8819177 52.9459651,13.1315438 C52.9459651,13.1315438 21.6258167,12.9439503 13.0500618,13.3191372 C12.304344,13.3191372 11.9314851,12.3811698 12.4907735,11.8183894 C15.1007858,9.19208063 19.9479516,4.50224357 23.3036818,3.37668268 C23.3036818,3.37668268 23.3036818,3.37668268 23.3036818,3.37668268",
    id: "Fill-46",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8465036,12.0059829 C15.2872153,12.0059829 14.9143564,11.2556089 15.4736447,10.6928285 C18.0836571,8.06651973 21.4393873,5.2526175 23.6765407,4.50224357 C24.608688,4.31465009 32.811584,2.81390223 41.3873389,2.81390223 C46.2345047,2.81390223 50.1495233,3.37668268 53.1323945,4.31465009 C53.5052535,4.31465009 53.6916829,4.68983705 53.6916829,5.06502402 C53.6916829,7.69133277 53.5052535,10.3176415 53.318824,11.6307959 C53.318824,12.0059829 52.9459651,12.1935763 52.5731062,12.1935763 C50.5223822,12.1935763 43.6244924,12.1935763 35.9808847,12.1935763 C25.5408353,11.8183894 19.3886633,11.8183894 15.8465036,12.0059829",
    id: "Fill-48",
    fill: "#E4E3FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96",
    transform: "translate(0.000000, 11.258299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.1107815,3.98274339 L58.4836404,5.10830428 C58.4836404,5.10830428 65.3815302,5.85867821 67.0593953,3.79514991 C67.0593953,3.79514991 67.4322542,-1.08228063 60.1615055,0.606060712 C59.4157876,0.793654194 60.1615055,3.79514991 60.1615055,3.79514991 C60.1615055,3.79514991 58.8564993,4.17033687 58.1107815,3.98274339",
    id: "Fill-72",
    fill: "var(--tru-grey-200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8431927,14.97086 C70.8431927,14.97086 71.5889105,12.7197382 72.1481989,15.9088274 C72.7074873,19.2855101 72.3346284,22.6621928 72.1481989,22.6621928 C71.77534,22.8497863 72.1481989,19.0979166 70.8431927,14.97086",
    id: "Fill-74",
    fill: "var(--tru-dark)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3016953,15.346047 C56.3016953,15.346047 57.9795604,15.7212339 59.6574255,18.7227296 C59.6574255,18.7227296 60.0302844,12.9073317 58.3524193,12.9073317 C58.3524193,12.9073317 57.0474131,12.9073317 56.3016953,15.346047",
    id: "Fill-76",
    fill: "var(--tru-dark)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.1481989,23.7877537 C72.1481989,23.7877537 72.7074873,14.0328926 71.2160516,14.595673 C71.2160516,14.595673 70.4703338,15.1584535 69.724616,17.5971688 C69.724616,17.5971688 69.3517571,14.97086 70.8431927,13.6577056 C71.4024811,13.2825187 72.1481989,13.4701121 72.3346284,14.0328926 C72.7074873,16.2840144 73.826064,21.3490384 72.1481989,23.7877537",
    id: "Fill-78",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7430691,28.4775907 C32.811584,28.8527777 11.9314851,29.0403712 2.98287127,28.1024038 L2.98287127,27.9148103 C2.98287127,27.9148103 2.79644182,27.1644363 3.16930073,26.6016559 C3.54215964,26.0388754 3.72858909,25.100908 4.101448,24.9133146 L4.101448,24.9133146 C4.28787745,24.9133146 4.84716582,16.2840144 9.13504327,15.346047 C9.13504327,15.346047 17.3379393,12.1569578 18.456516,12.5321447 C19.5750927,13.0949252 29.8287127,12.5321447 29.8287127,12.5321447 C29.8287127,12.5321447 39.5230444,13.8452991 41.7601978,17.5971688 C41.7601978,17.5971688 44.1837807,22.2870058 44.3702102,24.9133146 L44.7430691,28.4775907 Z",
    id: "Fill-80",
    fill: "#7C809B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7088116,15.9088274 C50.7088116,15.9088274 53.5052535,23.2249732 50.7088116,24.9133146 C50.7088116,24.9133146 46.2345047,26.7892494 45.8616458,21.5366319 C45.6752164,19.6606971 48.0987993,18.3475427 50.7088116,15.9088274",
    id: "Fill-82",
    fill: "#1E1E1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7088116,15.7212339 C50.7088116,15.7212339 53.6916829,22.8497863 50.7088116,24.9133146 C50.7088116,24.9133146 46.2345047,26.7892494 45.8616458,21.5366319 C45.6752164,19.6606971 48.0987993,18.3475427 50.7088116,15.7212339",
    id: "Fill-84",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.7088116,15.7212339 C50.7088116,15.7212339 53.6916829,22.8497863 50.8952411,24.5381276 C50.8952411,24.5381276 46.6073636,26.7892494 46.2345047,21.3490384 C46.0480753,19.6606971 48.0987993,18.9103231 50.7088116,15.7212339",
    id: "Fill-86",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.745717818,16.0964209 C0.745717818,17.2219818 -0.186429455,23.7877537 0.186429455,24.3505341 C0.186429455,24.3505341 2.050724,25.851282 3.16930073,24.1629406 C4.28787745,22.4745993 2.98287127,18.1599492 0.745717818,16.0964209 C0.932147273,16.0964209 0.745717818,16.0964209 0.745717818,16.0964209",
    id: "Fill-88",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.932147273,17.4095753 C0.745717818,19.0979166 0.186429455,23.2249732 0.372858909,24.1629406 C0.372858909,24.1629406 0.372858909,24.3505341 0.559288364,24.3505341 C0.932147273,24.7257211 2.42358291,25.476095 3.54215964,24.1629406 C4.66073636,22.6621928 3.35573018,19.2855101 1.67786509,17.2219818 C1.30500618,17.0343883 0.932147273,17.2219818 0.932147273,17.4095753",
    id: "Fill-90",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5381865,20.7862579 C69.5381865,20.7862579 69.724616,26.4140624 67.3010331,26.7892494 L60.7760022,27.5396233 L61.1488611,25.100908 L67.4874625,24.3505341 C67.4874625,24.3505341 68.4196098,24.1629406 69.5381865,19.8482905 C69.5381865,19.6606971 69.724616,19.4731036 69.724616,19.2855101 C69.5381865,19.6606971 69.5381865,20.2234775 69.5381865,20.7862579",
    id: "Fill-92",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5559775,18.3475427 C55.5559775,18.3475427 56.1152658,11.0313969 59.0981371,12.5321447 C59.6574255,12.9073317 60.4031433,14.2204861 59.8438549,18.7227296 C59.8438549,18.7227296 59.470996,12.7197382 58.1659898,13.2825187 C57.9795604,13.0949252 57.2338425,12.9073317 55.5559775,18.3475427",
    id: "Fill-94",
    fill: "#CEC8C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-161",
    transform: "translate(0.000000, 15.988350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.9294985,24.3871527 C33.1844429,24.7623396 12.304344,24.9499331 3.35573018,24.0119657 L3.35573018,23.8243722 C3.35573018,23.8243722 3.16930073,23.0739983 3.54215964,22.5112179 C3.91501855,21.9484374 4.101448,21.01047 4.47430691,20.8228765 L4.47430691,20.8228765 L9.69433164,22.3236244 C9.69433164,22.3236244 36.3537436,22.8864048 36.913032,22.6988113 C37.6587498,22.5112179 44.3702102,21.01047 44.3702102,21.01047 L44.7430691,22.8864048 L44.9294985,24.3871527 Z",
    id: "Fill-137",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8102596,21.5732505 L54.8102596,21.5732505 L54.6238302,22.3236244 L54.6238302,22.3236244 C54.4374007,22.8864048 54.0645418,23.6367788 53.6916829,24.1995592 C53.6916829,24.1995592 50.3359527,24.3871527 45.115928,24.3871527 C33.3708724,24.7623396 12.4907735,24.9499331 3.54215964,24.0119657 C2.61001236,24.0119657 1.86429455,23.8243722 1.30500618,23.6367788 C1.30500618,23.6367788 0.559288364,22.5112179 0.186429455,21.1980635 C1.49143564,21.7608439 9.13504327,24.5747462 20.6936695,23.6367788 C20.6936695,23.6367788 45.3023575,23.8243722 48.0987993,22.3236244 C49.0309465,21.7608439 52.0138178,20.4476896 52.0138178,20.4476896 C52.0138178,20.4476896 52.5731062,21.5732505 52.9459651,21.7608439 C53.1323945,22.1360309 54.8102596,21.5732505 54.8102596,21.5732505",
    id: "Fill-139",
    fill: "#CACAC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.76086,17.2586004 L16.0329331,17.2586004 C14.7279269,17.2586004 13.6093502,16.1330395 13.6093502,14.8198851 C13.6093502,13.5067307 14.7279269,12.3811698 16.0329331,12.3811698 L30.76086,12.3811698 C32.0658662,12.3811698 33.1844429,13.5067307 33.1844429,14.8198851 C33.1844429,16.1330395 32.0658662,17.2586004 30.76086,17.2586004",
    id: "Fill-141",
    fill: "var(--tru-grey-200)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.35573018,22.8864048 C3.72858909,22.3236244 3.91501855,21.385657 4.28787745,21.1980635 L4.28787745,21.1980635 C4.47430691,21.1980635 5.03359527,12.5687633 9.13504327,11.6307959 C9.13504327,11.6307959 17.3379393,8.4417067 18.456516,8.81689366 C19.5750927,9.37967411 29.8287127,8.81689366 29.8287127,8.81689366 C29.8287127,8.81689366 39.5230444,10.130048 41.7601978,13.8819177 C41.7601978,13.8819177 44.1837807,18.5717547 44.3702102,21.1980635 L44.9294985,24.3871527 L45.6752164,24.3871527 L45.115928,21.1980635 C44.9294985,18.5717547 42.5059156,13.8819177 42.3194862,13.6943242 C39.8959033,9.56726759 30.2015716,8.25411322 29.8287127,8.25411322 L29.8287127,8.25411322 L29.8287127,8.25411322 C29.8287127,8.25411322 25.7272647,8.4417067 22.557964,8.4417067 C19.5750927,8.4417067 19.0158044,8.25411322 19.0158044,8.25411322 C18.8293749,8.25411322 18.6429455,8.06651973 18.2700865,8.06651973 C16.2193625,8.06651973 10.0671905,10.505235 9.13504327,10.880422 C5.40645418,11.8183894 4.28787745,17.6337873 3.91501855,20.0725026 C3.91501855,20.2600961 3.91501855,20.4476896 3.72858909,20.635283 C3.54215964,20.8228765 3.35573018,21.1980635 3.16930073,21.7608439 C2.98287127,21.9484374 2.98287127,22.3236244 2.79644182,22.5112179 C2.23715345,23.4491853 2.61001236,24.0119657 2.61001236,24.0119657 L3.54215964,24.0119657 C3.35573018,24.0119657 2.98287127,23.4491853 3.35573018,22.8864048",
    id: "Fill-143",
    fill: "#CEC8C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25362,4.50224357 C10.25362,4.50224357 19.5750927,4.87743054 20.3208105,4.68983705 C20.3208105,4.68983705 23.6765407,1.50074786 28.1508476,4.68983705 C28.1508476,4.68983705 40.6416211,4.50224357 41.7601978,4.31465009 C41.7601978,4.31465009 38.963756,6.56577188 38.5908971,8.06651973 C38.5908971,8.06651973 31.3201484,7.87892625 29.6422833,8.62930018 C28.3372771,9.37967411 23.3036818,14.6322916 18.2700865,8.81689366 C18.2700865,8.81689366 12.304344,7.50373929 11.1857673,7.69133277 C11.1857673,7.69133277 10.8129084,6.56577188 10.25362,4.50224357",
    id: "Fill-145",
    fill: "#7C809B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8129084,6.37817839 L18.8293749,7.50373929 C18.8293749,7.50373929 23.3036818,14.4446981 29.4558538,7.50373929 L39.5230444,6.56577188 L40.2687622,5.81539795 C40.2687622,5.81539795 29.0829949,6.75336536 28.5237065,7.12855232 C28.5237065,7.12855232 24.0493996,13.3191372 20.1343811,7.12855232 L10.4400495,5.44021098 L10.8129084,6.37817839 Z",
    id: "Fill-147",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.659412,6.56577188 C26.659412,7.69133277 25.3544058,8.4417067 23.8629702,8.4417067 C22.3715345,8.4417067 21.0665284,7.50373929 21.0665284,6.56577188 C21.0665284,5.44021098 22.3715345,4.68983705 23.8629702,4.68983705 C25.5408353,4.68983705 26.659412,5.44021098 26.659412,6.56577188",
    id: "Fill-149",
    fill: "#ECE9E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1857673,8.62930018 C11.1857673,8.62930018 4.84716582,7.31614581 3.54215964,7.87892625 C3.54215964,7.87892625 2.42358291,7.87892625 2.23715345,7.50373929 C2.23715345,7.50373929 2.050724,4.68983705 3.91501855,2.62630875 C4.66073636,1.87593482 5.59288364,1.12556089 6.89788982,0.750373929 C6.89788982,0.750373929 8.01646654,2.62630875 8.94861382,3.75186964 L8.94861382,3.75186964 C9.32147273,4.12705661 9.88076109,4.50224357 10.0671905,4.50224357 C10.25362,4.31465009 11.9314851,8.06651973 11.1857673,8.62930018",
    id: "Fill-151",
    fill: "var(--tru-extreme-lightgrey)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5052535,3.00149572 C53.5052535,3.00149572 52.5731062,9.37967411 49.0309465,7.87892625 C49.0309465,7.87892625 41.5737684,8.06651973 38.4044676,8.4417067 C38.4044676,8.4417067 39.3366149,5.44021098 42.8787745,3.56427616 C43.8109218,3.1890892 44.7430691,2.81390223 46.0480753,2.43871527 C46.0480753,2.43871527 50.8952411,0.937967411 51.2681,0.562780447 C51.2681,0.562780447 53.318824,0.937967411 53.6916829,2.25112179 C53.6916829,2.43871527 53.6916829,2.62630875 53.5052535,3.00149572",
    id: "Fill-153",
    fill: "var(--tru-extreme-lightgrey)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.13504327,3.56427616 C8.94861382,3.56427616 5.59288364,3.75186964 4.101448,2.62630875 C4.84716582,1.87593482 5.77931309,1.12556089 7.08431927,0.750373929 C7.08431927,0.562780447 8.202896,2.43871527 9.13504327,3.56427616",
    id: "Fill-155",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5052535,2.25112179 L53.5052535,2.25112179 C53.5052535,2.25112179 48.4716582,5.2526175 42.8787745,3.56427616 C43.8109218,3.1890892 44.7430691,2.81390223 46.0480753,2.43871527 C46.0480753,2.43871527 50.8952411,0.937967411 51.2681,0.562780447 C51.2681,0.375186964 53.318824,0.750373929 53.5052535,2.25112179",
    id: "Fill-157",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6910207,0.187593482 C64.6910207,0.187593482 68.6060393,7.87892625 65.2503091,20.8228765",
    id: "Stroke-159",
    stroke: "#CCCCCC",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "var(--tru-grey-400)",
    points: "498.512361 172.773597 517.341736 172.773597 517.341736 115.369992 498.512361 115.369992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "var(--tru-gunmetal)",
    points: "498.512361 172.773597 502.986668 172.773597 502.986668 115.369992 498.512361 115.369992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "var(--tru-grey-400)",
    points: "531.510375 189.469417 550.33975 189.469417 550.33975 115.369992 531.510375 115.369992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "var(--tru-gunmetal)",
    points: "531.510375 189.469417 535.798252 189.469417 535.798252 115.369992 531.510375 115.369992"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "var(--tru-grey-400)",
    points: "606.268586 98.8617651 638.148023 98.8617651 638.148023 56.0904512 606.268586 56.0904512"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "var(--tru-grey-400)",
    points: "612.793617 98.8617651 631.622992 98.8617651 631.622992 68.096434 612.793617 68.096434"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FFFFFF",
    points: "627.335115 98.8617651 631.622992 98.8617651 631.622992 68.096434 627.335115 68.096434"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-55",
    transform: "translate(577.139903, 56.064222)",
    fill: "url(#linearGradient-10)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-53",
    points: "29.0829949 0 0 0 29.0829949 42.7713139 29.0829949 0"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#A3A3B0",
    points: "507.088116 172.773597 517.341736 172.773597 517.341736 124.937259 507.088116 124.937259"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#A3A3B0",
    points: "540.08613 189.469417 550.33975 189.469417 550.33975 124.937259 540.08613 124.937259"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "535.798252 134.69212 550.33975 134.69212 550.33975 132.065811 535.798252 132.065811"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-59",
    fill: "#FFFFFF",
    points: "502.986668 134.69212 517.341736 134.69212 517.341736 132.065811 502.986668 132.065811"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-60",
    fill: "#A3A3B0",
    points: "616.895065 98.8617651 627.335115 98.8617651 627.335115 77.4761081 616.895065 77.4761081"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    points: "431.024899 189.469417 429.160604 189.469417 429.160604 169.021727 432.143476 169.021727 431.024899 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-62",
    fill: "#FFFFFF",
    points: "442.397096 189.469417 440.532801 189.469417 437.3635 169.021727 440.346372 169.021727 442.397096 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-63",
    fill: "#FFFFFF",
    points: "442.397096 151.575534 440.90566 151.575534 437.3635 169.021727 440.346372 169.021727 442.397096 151.575534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#FFFFFF",
    points: "429.160604 172.773597 440.346372 172.773597 440.346372 169.021727 429.160604 169.021727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "434.939917 172.773597 443.142813 172.773597 443.142813 169.021727 434.939917 169.021727"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-66",
    fill: "#FFFFFF",
    points: "382.9261 189.469417 381.061805 189.469417 381.061805 169.021727 384.044676 169.021727 382.9261 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-67",
    fill: "#FFFFFF",
    points: "394.298296 189.469417 392.620431 189.469417 389.264701 169.021727 392.247572 169.021727 394.298296 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    points: "394.298296 151.575534 392.806861 151.575534 389.264701 169.021727 392.247572 169.021727 394.298296 151.575534"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-69",
    fill: "#FFFFFF",
    points: "381.061805 172.773597 392.247572 172.773597 392.247572 169.021727 381.061805 169.021727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#FFFFFF",
    points: "376.960357 172.773597 434.939917 172.773597 434.939917 169.021727 376.960357 169.021727"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-71",
    fill: "#FFFFFF",
    points: "387.027548 155.327403 444.820679 155.327403 445.566396 151.575534 387.773265 151.575534 387.027548 155.327403"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "#FFFFFF",
    points: "385.908971 161.142801 443.888531 161.142801 444.44782 157.390932 386.654689 157.390932 385.908971 161.142801"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-75",
    transform: "translate(303.253472, 28.850947)",
    fill: "url(#linearGradient-11)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.620519,36.2055421 C107.383366,32.4536724 102.5362,28.7018028 96.5704574,27.9514288 C86.6896964,26.450681 90.0454265,15.3826655 81.2832422,12.3811698 C72.1481989,9.19208063 71.4024811,16.6958199 47.9123698,3.37668268 C41.3873389,-0.375186964 29.2694244,-1.50074786 23.8629702,5.62780447 C20.6936695,9.75486107 19.9479516,15.7578525 20.8800989,20.8228765 C21.8122462,25.7003071 25.3544058,32.6412659 21.4393873,36.955916 C17.7107982,41.0829726 11.1857673,39.7698182 6.71146036,42.396127 C2.050724,45.0224357 0.372858909,50.4626467 0.372858909,55.5276707 C0.186429455,67.3460601 5.22002473,80.1024169 12.6772029,89.2944975 C28.1508476,108.053846 56.3016953,112.743683 78.4868004,104.48957 C91.5368622,99.612139 101.790482,89.857278 107.756225,77.2885147 C113.535538,65.0949383 117.077697,48.2115249 109.620519,36.2055421",
    id: "Fill-73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78",
    transform: "translate(303.253472, 28.850947)",
    fill: "url(#linearGradient-12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9446407,11.6307959 C70.0974749,11.8183894 64.8774502,12.9439503 48.0987993,3.37668268 C41.5737684,-0.375186964 29.4558538,-1.50074786 24.0493996,5.62780447 C20.8800989,9.75486107 20.1343811,15.7578525 21.0665284,20.8228765 C21.9986756,25.7003071 25.5408353,32.6412659 21.6258167,36.955916 C17.8972276,41.0829726 11.3721967,39.7698182 6.89788982,42.396127 C2.23715345,45.0224357 0.559288364,50.4626467 0.559288364,55.5276707 C0.372858909,67.3460601 5.40645418,80.1024169 12.8636324,89.2944975 C13.6093502,90.2324649 14.355068,90.9828389 15.1007858,91.7332128 C43.2516335,107.115878 22.9308229,60.0299143 32.2522956,51.5882076 C38.2180382,46.1479966 49.7766644,53.8393294 54.9966891,50.0874597 C57.6067015,48.2115249 57.420272,44.4596553 55.369548,41.645753 C49.0309465,32.8288594 38.963756,23.4491853 43.9973513,18.1965678 C46.6073636,15.3826655 52.0138178,16.8834134 62.0810084,16.8834134 C73.6396345,16.8834134 79.6053771,13.6943242 74.9446407,11.6307959",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-79",
    fill: "#D6D6D6",
    points: "365.58816 189.469417 359.808847 189.469417 359.622418 151.200347 353.283816 91.7332128 354.775252 89.857278 362.978148 147.823664 368.757461 109.742187 370.248897 111.055341 364.469584 154.577029 365.58816 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "var(--tru-grey-400)",
    points: "380.502517 106.553098 367.079596 126.438007 367.079596 124.937259 379.756799 105.802724 380.502517 106.553098"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-81",
    fill: "var(--tru-grey-400)",
    points: "357.198835 122.123357 345.640209 106.365504 346.385927 105.802724 357.385264 120.059829 357.198835 122.123357"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    fill: "var(--tru-grey-400)",
    points: "359.995277 88.7317171 356.639547 107.491065 355.893829 105.802724 359.249559 88.5441236 359.995277 88.7317171"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-85",
    transform: "translate(697.615991, 154.319015)",
    fill: "url(#linearGradient-13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.074387,35.0799812 C169.091515,27.9514288 154.550018,13.8819177 135.907072,17.6337873 C115.586262,21.9484374 111.111955,12.7563568 102.722629,9.00448715 C87.4354142,2.0635283 79.7918065,19.3221287 70.2839044,10.505235 C56.8609836,-1.87593482 46.0480753,-3.00149572 37.4723204,8.25411322 C24.9815469,24.5747462 4.66073636,6.56577188 0.186429455,35.0799812 L172.074387,35.0799812",
    id: "Fill-83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-88",
    transform: "translate(757.468651, 152.977110)",
    fill: "url(#linearGradient-14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.5546531,36.3931355 L0.186429455,36.3931355 C0.559288364,12.5687633 6.89788982,27.7638354 6.89788982,27.7638354 C6.89788982,27.7638354 8.94861382,10.3176415 13.4229207,9.56726759 C17.7107982,8.81689366 19.7615222,26.6382745 19.7615222,26.6382745 C19.7615222,26.6382745 24.4222585,1.12556089 30.5744305,0.187593482 C35.9808847,-0.375186964 31.6930073,24.0119657 31.6930073,24.0119657 C31.6930073,24.0119657 34.862308,21.5732505 39.3366149,21.385657 C44.3702102,21.1980635 42.3194862,26.075494 42.3194862,26.075494 C42.3194862,26.075494 48.6580876,15.0074786 52.7595356,15.1950721 C57.9795604,15.3826655 54.4374007,26.6382745 54.4374007,26.6382745 C54.4374007,26.6382745 58.3524193,22.8864048 62.2674378,22.5112179 C70.0974749,21.5732505 61.7081495,31.7032985 61.7081495,31.7032985 C61.7081495,31.7032985 67.3010331,29.4521767 76.9953647,27.9514288 C86.3168374,26.450681 84.4525429,31.890892 77.5546531,36.3931355",
    id: "Path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-91",
    transform: "translate(718.231907, 28.850947)",
    fill: "url(#linearGradient-15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.264789,27.0134614 C106.451219,12.7563568 93.9604451,8.25411322 81.8425305,12.3811698 C72.5210578,15.3826655 71.77534,16.6958199 48.4716582,3.37668268 C41.9466273,-0.375186964 29.8287127,-1.50074786 24.4222585,5.62780447 C21.2529578,9.75486107 20.50724,15.7578525 21.2529578,20.8228765 C22.1851051,25.7003071 25.7272647,32.6412659 21.6258167,36.955916 C17.8972276,41.0829726 11.3721967,39.7698182 6.89788982,42.396127 C2.23715345,45.0224357 0.559288364,50.4626467 0.372858909,55.5276707 C0.186429455,67.3460601 4.66073636,80.6651973 12.4907735,89.2944975 C28.3372771,106.740691 56.4881247,113.306463 82.2153894,106.740691 C139.449232,91.9208063 118.009845,61.1554752 111.298384,52.901362 C104.027636,44.0844683 106.07836,36.955916 106.264789,27.0134614",
    id: "Fill-89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-94",
    transform: "translate(718.231907, 28.850947)",
    fill: "url(#linearGradient-16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.4018189,12.1935763 C82.2153894,12.1935763 81.8425305,12.3811698 81.6561011,12.3811698 C72.5210578,15.3826655 71.77534,16.6958199 48.4716582,3.37668268 C41.9466273,-0.375186964 29.8287127,-1.50074786 24.4222585,5.62780447 C21.2529578,9.75486107 20.50724,15.7578525 21.2529578,20.8228765 C22.1851051,25.7003071 25.7272647,32.6412659 21.6258167,36.955916 C17.8972276,41.0829726 11.3721967,39.7698182 6.89788982,42.396127 C2.23715345,45.0224357 0.559288364,50.4626467 0.372858909,55.5276707 C0.186429455,67.3460601 5.03359527,80.1024169 12.4907735,89.2944975 C13.4229207,90.4200584 14.5414975,91.5456193 15.6600742,92.6711802 C41.2009095,108.241439 14.7279269,74.4746124 35.7944553,60.5926947 C46.2345047,53.6517359 66.3688858,46.3355901 57.6067015,35.4551681 C51.2681,27.3886484 46.4209342,24.1995592 48.2852287,19.8849091 C49.4038055,17.4461938 52.5731062,15.1950721 62.4538673,16.8834134 C75.876788,19.3221287 85.7575491,14.4446981 82.4018189,12.1935763",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-95",
    fill: "var(--tru-grey-400)",
    points: "778.715832 189.469417 784.495145 189.469417 783.935856 151.200347 785.054433 88.7317171 783.749427 86.8557823 780.580126 147.823664 772.004371 110.304968 770.512936 111.805715 778.902261 154.577029 778.715832 189.469417"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-96",
    fill: "var(--tru-grey-400)",
    points: "793.630188 97.5486107 783.749427 112.180902 783.749427 115.182398 794.562335 98.2989847 793.630188 97.5486107"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-97",
    fill: "var(--tru-grey-400)",
    points: "779.088691 91.9208063 783.376568 100.7377 783.376568 102.613635 778.342973 92.1083998 779.088691 91.9208063"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-98",
    fill: "var(--tru-grey-400)",
    points: "766.038629 115.369992 773.309377 121.935763 773.868666 123.624105 765.47934 115.745179 766.038629 115.369992"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.734285,189.469417 C751.683561,184.404393 749.632837,180.840117 747.954972,181.215304 C746.277107,181.590491 745.904248,184.967173 746.090677,189.469417 L753.734285,189.469417",
    id: "Fill-99",
    fill: "#B0B0BB"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default ForwardRef;